export default __webpack_public_path__ + "static/media/check green 6.4e3bbced.svg";